import { useMemo } from 'react';
import type { BasicRecord, SCAdvanceTableProps } from './types';

function useRowButtons<D extends BasicRecord>(props: SCAdvanceTableProps<D>) {
  const rowMap = useMemo(() => {
    const map: Record<string, D> = {};
    props.Rows?.forEach((row) => {
      map[row[props.IdField]] = row;
    });
    return map;
  }, [props.IdField, props.Rows]);

  const newRowButtons = useMemo(() => {
    return props.RowButtons?.filter((button) => button.Hidden !== true) // Exclude always-hidden buttons so eone-ui sizes the column correctly
      .map((button) => {
        return {
          ...button,
          OnClick: (idField: string) => {
            if (!props.Rows) return;
            const index = props.Rows.findIndex((row) => row[props.IdField] === idField);
            return button?.OnClick?.(idField, rowMap[idField], index);
          },
        };
      });
  }, [props.IdField, props.RowButtons, props.Rows, rowMap]);

  return {
    ...props,
    RowButtons: newRowButtons,
  };
}

export { useRowButtons };
